import React from 'react';
import axios from 'axios';
import { Alert, Form, Spin, Checkbox } from 'antd';

import apiPath from 'apiPath';
import moment from 'components/momentWithZone';
import passport from 'components/passportUtils';
import formItemLayout from 'components/Portal/formItemLayout';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';

import stickyError from 'components/stickyError';

class VisaWaive extends React.Component {
	state = {
		loading: true,
		visas: [],
	}

	handleWaiveSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.form.validateFields((err, values) => {
			if (err) {
				this.props.isSubmitted();
				return stickyError(err.message);
			}
			let requests = [];
			for (let visa in values) {
				if (values[visa] !== null)
					if (values[visa] === true) {
						{
							requests.push(axios.post(apiPath + '/visa/waive', {
								status: 'W',
								code: visa,
							}, { withCredentials: true }));
						}
					} else if (values[visa] === false) {
						{
							requests.push(axios.post(apiPath + '/visa/waive', {
								status: 'R',
								code: visa,
							}, { withCredentials: true }));
						}
					}
			}
			axios.all(requests).then(result => {
				this.props.isSubmitted();
			}).catch(error => {
				this.props.isSubmitted();
				stickyError('One or more visa expiry dates may not have been saved, please try again.')
			});
		});
	}

	checked = (event) => {
		let eventClick = event.target
		this.setState({
			[eventClick.value]: event.target.checked
		})
	}

	componentWillMount() {
		axios.get(apiPath + '/visa/waive', { withCredentials: true }).then(result => {
			this.setState({ visas: result.data, loading: false });
		})
			.catch(error => {
				stickyError('Error loading visa statuses');
			});
	}
	render() {

		if (this.state.loading) return <Spin />;

		const { getFieldDecorator } = this.props.form;

		return (
			<div>
				<Form onSubmit={this.handleWaiveSubmit}>
					<p>
						Check the box if you want to waive a visa.  It will then be waived for this student.
				</p>
					{this.state.visas.map(visa =>
						<Form.Item label={visa.COUNTRY_NAME} key={visa.VS_VISA_CODE} {...formItemLayout}>
							{getFieldDecorator(visa.VS_VISA_CODE, {
								initialValue: (visa.VS_VISA_STATUS !== "W") ? false : true
							})(
								<Checkbox onChange={this.checked} defaultChecked={(visa.VS_VISA_STATUS !== "W") ? false : true} />
							)}
						</Form.Item>
					)}
					<SaveButton
						loading={this.props.getStatus().submitting} />
				</Form>
			</div>
		);
	}
}

export default withSpin(Form.create()(VisaWaive));


// WEBPACK FOOTER //
// ./portal-components/Portal/Travel/VisaWaive.jsx